module.exports = __webpack_public_path__ + "img/energy.3a4426c.svg";